module.exports = __webpack_public_path__ + "static/media/Scan 12.b46ef277.jpeg";